import React, { FC } from 'react';
import {
  Button,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from 'reactstrap';
import * as OrderSummary from '../../../../../shared/orders/model';
import { JSONForm } from '../../../../components/json-form/JSONForm';
import { useTranslation } from '../../../../translations';
import { displayName } from '../../../../utils';
import { isOrderItemFulfillable } from './utils';

interface OrderFulfillModalProps {
  readonly order: OrderSummary.Order;
  readonly onSuccess: () => void;
  readonly onCancel: () => void;
}

export const OrderFulfillModal: FC<OrderFulfillModalProps> = ({ order, onCancel, onSuccess }) => {
  const { ts } = useTranslation();
  const unfulfilledItems = order.orderItems.filter((oi) => isOrderItemFulfillable(oi));

  return (
    <Modal className="modal-large" id="fulfillModal" isOpen>
      <JSONForm method="patch" onSuccess={onSuccess} path={`/api/users/${order.userId}/fulfill`}>
        <ModalHeader>{ts('order_fulfill_modal.fulfill_order', order.id)}</ModalHeader>
        <ModalBody>
          <p>
            {ts('order_fulfill_modal.the_selected_items_will_be')}
            <br />
            {ts('order_fulfill_modal.at_this_time_it_is')}
          </p>
          <Table striped>
            <thead>
              <tr>
                <th>{ts('common.product_name')}</th>
                <th>{ts('common.fulfilled_question')}</th>
              </tr>
            </thead>
            <tbody>
              {unfulfilledItems.map((item) => (
                <OrderFulfillModalItem item={item} key={item.id} />
              ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={onCancel}>
            {ts('common.cancel')}
          </Button>{' '}
          <Button color="primary" id="fulfillOrder" type="submit">
            {ts('order_fulfill_modal.fulfill_order', order.id)}
          </Button>
        </ModalFooter>
      </JSONForm>
    </Modal>
  );
};

interface OrderFulfillModalItemProps {
  readonly item: OrderSummary.OrderItem;
}

const OrderFulfillModalItem: FC<OrderFulfillModalItemProps> = ({ item }) => {
  return (
    <tr>
      <td>{displayName(item.product)}</td>
      <td>
        <FormGroup check>
          <Input id={`orderItem${item.id}`} name="orderItemIds[]" type="checkbox" value={item.id} />
          <Label check for={`orderItem${item.id}`} />
        </FormGroup>
      </td>
    </tr>
  );
};
